import Option from "./Option";
import { formatPhoneNumber } from "../util/ValidationUtils";
import { LocationManagerData } from "../views/create-location-wizard/types";

class LocationManagerOption extends Option<LocationManagerData | null> {
    displayPhoneNumber: string;
    displayValue: string;

    constructor(locationManager: LocationManagerData | null) {
        super(locationManager);

        this.displayPhoneNumber = '';
        this.displayValue = '';

        // Guard against null (used by legacy code to represent a "None" option)
        if (locationManager === null) {
            this.displayValue = "None";
            return;
        }

        const {username, phoneNumber, firstName, lastName} = locationManager;

        if (phoneNumber) {
            this.displayPhoneNumber = formatPhoneNumber(phoneNumber);
        }
        if (firstName && lastName && phoneNumber) {
            this.displayValue = `${firstName} ${lastName} - ${this.displayPhoneNumber}`;
        } else if (username) {
            this.displayValue = username;
        }
    }

    getValue(): LocationManagerData | null {
        return this.value;
    }

    getDisplayValue(): string {
        return this.displayValue;
    }
}

export default LocationManagerOption;
